import { LayoutState } from '../../models/layout'

export const selectSocialHubConfiguration = (state: {
    layoutReducer: LayoutState
}) => state.layoutReducer.socialHubConfiguration
